import { formatTaka } from '@/utils/number';
import type { PcmpSubmissionCalculation } from '../../types/pcmpProposal.types';
import { PcmpAmountTile } from './PcmpAmountTile';
import { PcmpProposalSection } from './PcmpProposalSection';

interface PcmpCalculationCardProps {
  calculation: PcmpSubmissionCalculation;
}

const formatPercent = (value: number): string => `${Number(value.toFixed(2))}%`;

/** Institute-wide money position and targets (legacy "Institute Calculation"). */
export function PcmpCalculationCard({ calculation }: PcmpCalculationCardProps) {
  const { categorySplit } = calculation;
  return (
    <PcmpProposalSection title="Institute Calculation">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        <PcmpAmountTile label="Total MP" value={formatTaka(calculation.agreed)} />
        <PcmpAmountTile
          label="Disbursed"
          value={formatTaka(calculation.disbursed)}
          tone="success"
        />
        <PcmpAmountTile label="In flight" value={formatTaka(calculation.inFlight)} tone="info" />
        <PcmpAmountTile label="Due" value={formatTaka(calculation.due)} tone="warning" />
        {calculation.extra > 0 ? (
          <PcmpAmountTile label="Overpaid" value={formatTaka(calculation.extra)} tone="danger" />
        ) : null}
        <PcmpAmountTile label="Sales target" value={formatTaka(calculation.totalSalesTarget)} />
        <PcmpAmountTile label="Total CMP" value={formatPercent(calculation.totalCmpPercent)} />
        <PcmpAmountTile label="Per student cost" value={formatTaka(calculation.perStudentCost)} />
        {categorySplit ? (
          <>
            <PcmpAmountTile
              label="Grammar share"
              value={`${formatPercent(categorySplit.grammarPercent)} · ${formatTaka(categorySplit.grammar)}`}
            />
            <PcmpAmountTile
              label="Practice share"
              value={`${formatPercent(categorySplit.practicePercent)} · ${formatTaka(categorySplit.practice)}`}
            />
          </>
        ) : null}
      </div>
    </PcmpProposalSection>
  );
}
